/**
 * @generated SignedSource<<7b023ba9a95d78454bf08ef9df0b554e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CopyVisualAssetRequest = {
  id: string;
  metaAdId: string;
};
export type MetaAdCopyVisualAssetMutation$variables = {
  input: CopyVisualAssetRequest;
};
export type MetaAdCopyVisualAssetMutation$data = {
  readonly copyVisualAsset: {
    readonly id: string;
    readonly metaAdId: string | null;
  };
};
export type MetaAdCopyVisualAssetMutation = {
  response: MetaAdCopyVisualAssetMutation$data;
  variables: MetaAdCopyVisualAssetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CopyVisualAssetResolved",
    "kind": "LinkedField",
    "name": "copyVisualAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "metaAdId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MetaAdCopyVisualAssetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MetaAdCopyVisualAssetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "27c73567e87436dee56e7000d9e81979",
    "id": null,
    "metadata": {},
    "name": "MetaAdCopyVisualAssetMutation",
    "operationKind": "mutation",
    "text": "mutation MetaAdCopyVisualAssetMutation(\n  $input: CopyVisualAssetRequest!\n) {\n  copyVisualAsset(input: $input) {\n    id\n    metaAdId\n  }\n}\n"
  }
};
})();

(node as any).hash = "5d4425c864d0750d64279f68cc4e241f";

export default node;
